export enum BlogArticleType {
  GET_ARTICLES_SUCCESS = 'GET_ARTICLES_SUCCESS',

  GET_BLOG_COVER_SUCCESS = 'GET_BLOG_COVER_SUCCESS',
  SET_ARTICLES_QUERY = 'SET_ARTICLES_QUERY',
  SET_BLOG_COVER = 'SET_BLOG_COVER',
}
